<template>
  <div class="bg-white px-4 py-8 sm:p-12">
    <div class="mt-8 flex justify-center">
      <span class="text-2xl font-semibold mr-3">Deactivated</span>
      <ToggleButton
          :disabled="false"
          :state="order.active"
          @change="state => changeActivation(state)"
      >
        <span class="text-2xl font-semibold">Activated</span>
      </ToggleButton>
    </div>

    <h1
        class="font-semibold text-l lg:text-l max-w-4xl mx-auto text-center mt-10 mb-12"
    >
      Activate your event using the slider above. When activated,
      invitations and messages will be sent to attendees and the
      enrollment form will be available. The BuildaBox.co Event Platform
      is free for events of 25 or fewer attendees and no payment method is
      needed.
    </h1>

    <div v-if="!showPriceTable">
      <OrderPriceTable/>
    </div>

  </div>
</template>

<script>
import Spinner from '@/components/common/Spinner'
import { StripeElements } from 'vue-stripe-checkout'
import OrderPriceTable from '@/components/order/OrderPriceTable'
import ToggleButton from '@/components/common/controls/ToggleButton'
import ApiV1 from '@/api/api_v1.0'

export default {
  name      : 'Activation',
  components: { Spinner, StripeElements, OrderPriceTable, ToggleButton },
  data () {
    return {
      progressCheckout: false,
      license         : null
    }
  },
  computed: {
    order () {
      return this.$store.state.currentEditingOrder
    },
    accountVerified () {
      return this.$store.state.auth.user.verified
    },
    showPriceTable () {
      return this.license && this.license.name !== 'Free'
    }
  },
  mounted () {
    this.loadLicense()
  },
  methods: {
    async loadLicense () {
      const response = await ApiV1.getLicense()
      this.license = response.data
    },

    async changeActivation (state) {
      await ApiV1.changeOrderActiveState(this.order.uuid, state)
      const successMessage = state ? 'The event is activated!' : 'The event is deactivated!'
      this.$store.dispatch('setSuccessMessage', successMessage)

      let order = this.order
      order.active = state
      this.$store.commit('setCurrentEditingOrder', order)
    }
  },

}
</script>
